import { Box, CircularProgress } from '@mui/material'
import { useGetLicensedEstablishmentByCorporateAccount } from 'hooks/api/useGetLicensedEstablishmentByCorporateAccount'
import { LicenseDetailLicensedEstablishmentPage } from './LicenseDetailLicensedEstablishmentPage'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'
import { type LicensedEstablishment } from 'src/types/api'
import { getLEIdsByPermission } from 'utils/permissions'
import { useSetMe } from 'stores/useMeQuery'

export const LicensesListLicensedEstablishmentPage = () => {
  const { passedMe } = useSetMe()
  const meQuery = passedMe
  const selectedCorporateAccount =
    useCurrentCorporateAccountStore().currentCorporateAccountId
  const licensedEstablishmentsQuery =
    useGetLicensedEstablishmentByCorporateAccount({
      corporateAccountId: Number(selectedCorporateAccount),
    })

  // Get LE Ids for the permission the user has access to
  const leIdsByPermission: number[] = getLEIdsByPermission(
    meQuery.data,
    selectedCorporateAccount,
    'compliancePermission'
  )

  // Filter data by permission
  const licensedEstablishmentsFiltered =
    licensedEstablishmentsQuery.data?.filter((x) =>
      leIdsByPermission.includes(x.id)
    )

  if (licensedEstablishmentsQuery.isPending) {
    return <CircularProgress />
  }

  if (licensedEstablishmentsQuery.isError) {
    return <p>An error occurred.</p>
  }

  const sortedLicensedEstablishments = licensedEstablishmentsFiltered
    ? [...licensedEstablishmentsFiltered].sort(
        (a: LicensedEstablishment, b: LicensedEstablishment) => {
          return (a.standardName ?? '') > (b.standardName ?? '') ? 1 : -1
        }
      )
    : []

  return (
    <Box sx={{ py: 1 }}>
      {sortedLicensedEstablishments.map((licensedEstablishment) => {
        return (
          <LicenseDetailLicensedEstablishmentPage
            key={licensedEstablishment.id}
            licensedEstablishmentLicenseNumber={
              licensedEstablishment.licenseNumber
            }
            licensedEstablishmentName={
              licensedEstablishment.standardName ?? licensedEstablishment.name
            }
            licensedEstablishmentLicenses={
              licensedEstablishment.licensedEstablishmentLicenses ?? []
            }
            uniqueLicensedEstablishment={
              sortedLicensedEstablishments.length === 1
            }
          />
        )
      })}
    </Box>
  )
}
